// band
import concertHostGuidelines from '../../files/band/HostGuidelines.pdf';
import script from '../../files/band/region-script-copy.pdf';
import electronics from '../../files/band/Marching_Band_Electronics_FA_2022_2023.pdf';
import videoPolicy from '../../files/band/video-policy.pdf';
import seHostGuidelines from '../../files/band/se-hostGuidelines.pdf';
import marchingHost from '../../files/band/marching-host.pdf';
import sightreadingPilot from '../../files/orchestra/orchestra_script.pdf';
import bandPolicies from '../../files/band/2023_2024_TMEA_Region_20_Band_Policies.pdf';

import areaState5AdSheet from '../../files/band/20-21/2020-UIL-Area-State-5-person-panel-Adjudication-Sheets.pdf';
import stateAd7Sheet from '../../files/band/20-21/2020-UIL-State-7-person-panel-Adjudication-Sheets.pdf';
import militaryBandPilot from '../../files/band/20-21/State-Military-Marching-Band-Contest-Pilot.pdf';
import educationUseVideo from '../../files/band/20-21/Marching-Band-Educational-Use-Video-Agreement.pdf';
import chamberMusic from '../../files/band/20-21/State-Instrumental-Chamber-Music-Contest.pdf';

//19-20
import soloEventCodes from '../../files/band/19-20/2019-2020-New-S-and-E-Event-Codes.pdf';

// middle school band
import msAudition2020 from '../../files/band/middleSchool/All-Region-Auditon-Materials-for-Region-20-MS.pdf';

//choir
import choirConcertGuidelines from '../../files/choir/concert-guidelines.pdf';

//contest
import choirVarsityCSR from '../../files/choir/2019 HS UIL C & SR Contest Schedule FINAL 3.23.pdf';

// orchestra
import conGuidelines from '../../files/orchestra/Region 20 Orchestra C:SR Host Guidelines.pdf';
import soloGuidelines from '../../files/orchestra/Region 20 Orchestra:Mariachi Solo and Ensemble Host Guidelines1.pdf';

// mariachi
import intentLetter from '../../files/mariachi/MARIACHI LETTER OF INTENT.docx';
import studentHandbook from '../../files/mariachi/student_handbook.pdf';
import mariachiHandbook from '../../files/mariachi/2022-2023_TMEA_REGION_20_MARIACHI_DIRECTORS_HANDBOOK_AMENDED.pdf';

// general
import regionGuidelines from '../../files/general/region-guidelines.pdf';

// 20-21
import financialReport from '../../files/general/yearly_financial_report_22_23.pdf';

//band/choir divisions
import highSchoolDivisions from '../../files/band/20-21/high_school_zone.pdf';
import middleSchoolDivisions from '../../files/band/20-21/middle_school_zone.pdf';

// 2024
import entranceInstructions from '../../files/2024/INSTRUCTIONS_FOR_ENTERING_MARCHING_BAND_CONTEST.pdf';
import allContestEntrance from '../../files/2024/INSTRUCTIONS_FOR_ENTERING_C_SR_Contest_1_23_23.pdf';
import allSoloEntrance from '../../files/2024/INSTRUCTIONS_FOR_ENTERING_SOLO_AND_ENSEMBLE_CONTEST_1_6_23.pdf';
import uilSightreadingUpdates from '../../files/2024/Updates_for_UIL_Sightreading_1_6_23.pdf';

// 2024 band
import marchingSchedule6A2023 from '../../files/2024/band/2023_6A_Marching_Contest_Schedule_9_8_23.pdf';
import marchingSchedule5A2023 from '../../files/2024/band/2023_UIL_5A_Down_Marching_Schedule_9_22_23.pdf';

import execMinutes2024 from '../../files/2024/05_23_24_Executive_Committee_Minutes_Website.pdf';

import choirSightReadingPilot from '../../files/general/UIL_Choir_Sight_Reading_Instruction_Pilot.pdf';

// 24-25
import bandConcertEval24 from '../../files/24-25/Band_Concert_Evaluation_Rubric.pdf';
import bandForm4 from '../../files/24-25/Band_Form_4.pdf';
import bandForm5 from '../../files/24-25/Band_Form_5.pdf';
import bandSightReading from '../../files/24-25/Band_Sight_Reading_Rubric.pdf';
import regionMarchingAdjudication from '../../files/24-25/Region_Marching_Adjudication_Sheets.pdf';
import vocalConcertEval from '../../files/24-25/Vocal_Concert_Evaluation_Rubric.pdf';
import vocalForm4 from '../../files/24-25/Vocal_Form_4.pdf';
import vocalForm5 from '../../files/24-25/Vocal_Form_5.pdf';
import vocalSightReading from '../../files/24-25/Vocal_Sight_Reading_Evaluation_Rubric.pdf';
import orchConcertEval from '../../files/24-25/Orchestra_Concert_Evaluation_Rubric.pdf';
import orchForm4 from '../../files/24-25/Orchestra_Form_4.pdf';
import orchForm5 from '../../files/24-25/Orchestra_Form_5.pdf';
import orchSightReading from '../../files/24-25/Orchestra_Sight_reading_Evaluation_Rubric.pdf';
import mariachiRubric from '../../files/24-25/Mariachi_Rubric.pdf';
import mariachiForm4 from '../../files/24-25/Mariachi_Form_4.pdf';
import regionJudges24 from '../../files/24-25/2024_2025_UIL_Region_20_Judges.pdf';
import directorsCompliance from '../../files/24-25/Directors_Compliance_Update_2024.pdf';
import schedule2425 from '../../files/24-25/Region_20_Contest_Schedule_2024_2025_8_28_24.pdf';
import calendar2425 from '../../files/24-25/UIL_Region_20_Calendar_2024_2025_8_28_24.pdf';

// 25-26
// import calendar2526 from '../../files/25-26/UIL_Region_20_Calendar_2025_2026_7_8_25.pdf';
import calendar2526 from '../../files/25-26/UIL_Region_20_Calendar_2025_2026_7_17_25.pdf';
import minutes_2025 from '../../files/25-26/06_05_2025_Region_20_Executive_Committee_Minutes.pdf';
import financial_report_2025 from '../../files/25-26/Financial_Report_2024_2025.pdf';

// exec
import execMeeting2425 from '../../files/24-25/Executive_Committee_Meeting_Agenda_10_17_24.pdf';
import marchingContestSched5a24 from '../../files/24-25/2024_UIL_5A_Down_Marching_Schedule_10_3_24.pdf';
import marchingContestSched6a24 from '../../files/24-25/2024_UIL_6A_Marching_Contest_Schedule_9_25.pdf';
import execMinutes from '../../files/24-25/Region_20_UIL_minutes_October_17_2024.pdf';
import execMinute2025 from '../../files/25-26/Region_20_Executive_Committee_Minutes_Website_06_05_2025.pdf';
// import meetingAgenda2025 from '../../files/24-25/Executive_Committee_Meeting_Agenda_2_4_25.pdf'; // TODO -- remove
import meetingAgenda2025 from '../../files/24-25/Executive_Committee_Agenda_6_5_25.pdf';

// new shit (8/7/25)
import areaJ2025 from '../../files/25-26/Area_J_6A_Prelims_Draw_Order.pdf';
import areaB2025 from '../../files/25-26/Area_B_5A_Prelims_Draw_Order.pdf';

import contestSchedule_25 from '../../files/25-26/Region_20_Contest_Schedule_2025_2026_8_5_25.pdf';
import band_policies_25 from '../../files/25-26/2025_2026_TMEA_Region_20_Band_Policies.pdf';
import marching_contest_5a_2025 from '../../files/25-26/2025_UIL_5A_marching_contest.pdf';

// maybe find a more effecient way
export const FILE = {
  concertHostGuidelines,
  entranceInstructions,
  script,
  electronics,
  videoPolicy,
  seHostGuidelines,
  marchingHost,
  choirConcertGuidelines,
  conGuidelines,
  soloGuidelines,
  intentLetter,
  studentHandbook,
  regionGuidelines,
  mariachiHandbook,
  choirVarsityCSR,
  allSoloEntrance,
  allContestEntrance,
  soloEventCodes,
  sightreadingPilot,
  highSchoolDivisions,
  middleSchoolDivisions,
  financialReport,
  areaState5AdSheet,
  stateAd7Sheet,
  militaryBandPilot,
  educationUseVideo,
  chamberMusic,
  msAudition2020,
  bandPolicies,
  uilSightreadingUpdates,
  marchingSchedule5A2023, // not using
  marchingSchedule6A2023, // not using
  execMinutes2024,
  choirSightReadingPilot,
  // 24-25
  bandConcertEval24,
  bandForm4,
  bandForm5,
  bandSightReading,
  regionMarchingAdjudication,
  vocalConcertEval,
  vocalForm4,
  vocalForm5,
  vocalSightReading,
  orchConcertEval,
  orchForm4,
  orchForm5,
  orchSightReading,
  mariachiRubric,
  mariachiForm4,
  regionJudges24,
  directorsCompliance,
  schedule2425,
  calendar2425,
  calendar2526,
  execMeeting2425,
  marchingContestSched5a24,
  marchingContestSched6a24,
  execMinutes,
  execMinute2025,
  meetingAgenda2025,
  minutes_2025,
  financial_report_2025,
  areaJ2025,
  areaB2025,
  band_policies_25,
  contestSchedule_25,
  marching_contest_5a_2025,
};



// WEBPACK FOOTER //
// ./src/utils/constants/pdf.js